module.exports = __webpack_public_path__ + "media/images/favicons/icon-512x512-d1bfe974e0981f0d02c44cd4c3183975.png";